import React, { useEffect, useRef } from 'react';
import { FileButton, Text, Input, Group, Image, UnstyledButton } from '@mantine/core';
import { FieldPropsType } from "../../Editor";
import Translation from "../../../Utils/Translation";
import useReadOnly from "../useReadOnly";
import { get } from "../../../../utils/object";
import { useEffectOnMount } from "../../../Utils/useEffectOnMount";

export const view = null;

const defaultImage = "data:image/png;base64,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";

const size = 300;

const isBlob = value =>
    value &&
    typeof value.size === 'number' &&
    typeof value.type === 'string' &&
    typeof value.slice === 'function';

const isFile = (value): value is File =>
    isBlob(value) &&
    typeof value.name === 'string' &&
    (typeof value.lastModifiedDate === 'object' ||
        typeof value.lastModified === 'number');

const Preview = ({ file, disabled, onClick }: { file: File | { id: number, name: string, path: string } | undefined, disabled?: boolean, onClick?: (event: any) => void }) => {
    const names = file?.name?.split("_") ?? [];
    names.shift();
    return (
        <UnstyledButton
            style={{ width: "100%" }}
            onClick={(event) => {
                !disabled && onClick?.(event);
            }}
        >
            <Image
                maw={size}
                miw={size}
                radius="md"
                src={isFile(file) ? URL.createObjectURL(file) : (file ? `${file.path}${file.name}` : defaultImage)}
                alt={file?.name}
                title={names.join("_")}
                withPlaceholder
                placeholder={<Text align="center"><Translation id="loading" /></Text>}
            />
        </UnstyledButton>
    );
}

const FileInput = (props: FieldPropsType) => {
    const form = props.form;
    const field = props.field;
    const fieldName = field.split(".");
    const index = fieldName.length > 1 ? Number(fieldName.pop()) : null;
    const isList = !isNaN(index);
    const currentField = fieldName.shift();
    const fieldSettings = props.config?.fields?.[currentField];
    const value = get(form.values, field);
    const inputRef = useRef<HTMLInputElement>();
    const fieldReadOnly = useReadOnly(props);
    useEffectOnMount(() => {
        const file = value;
        if (file instanceof File) {
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(file);
            if (inputRef?.current) {
                inputRef.current.files = dataTransfer.files;
            }
        }
    });
    useEffect(() => {
        const file = value;
        if (file instanceof File) {
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(file);
            if (inputRef?.current) {
                inputRef.current.files = dataTransfer.files;
            }
        }
    }, [value]);
    // @ts-ignore
    const fileInput = <FileButton ref={inputRef}
        onChange={(newValue: File & { [key: string]: any }) => {
            if (newValue) {
                if (value) {
                    Object.entries(value).forEach(([key, value]) => {
                        try {
                            newValue[key] = value;
                        } catch (e) {
                        }
                    });
                }
                form.setFieldValue(field, newValue);
            }
        }}
        accept="image/png,image/jpeg"
    >
        {(buttonProps) => {
            return <Preview
                {...buttonProps}
                disabled={fieldReadOnly || props.readOnly}
                file={value}
            />
        }}
    </FileButton>;
    if (isList) {
        return fileInput;
    }
    return (
        <>
            <Input.Wrapper
                label={<Translation base={[props.config.componentName + ".field." + currentField, props.config.componentName]} id={currentField} />}
                withAsterisk={fieldSettings.required}
                error={form.errors?.[field]}
            >
                <Group position="center">
                    {fileInput}
                </Group>
            </Input.Wrapper>
        </>
    );
}

export {
    Preview
}

export default FileInput;